/**
 * 报表打印跳转工具 (Vue Mixin)
 *
 * 使用方式：
 *   import reportPrintHelper from '@/utils/reportPrintHelper'
 *   export default {
 *     mixins: [reportPrintHelper],
 *     // ... 其他
 *   }
 *
 *   模板中调用：
 *     <a-button @click="goReportPrint('ITEM_DETAIL', '收支项明细', dataSource)">打印</a-button>
 *     <a-button @click="goReportPrint('ITEM_DETAIL', '收支项明细', dataSource, { autoPrint: true })">直接打印</a-button>
 */
export default {
  methods: {
    /**
     * 跳转到报表打印预览页
     *
     * @param {string} billType - 报表类型编码 (如 'ITEM_DETAIL', 'SALES_RANKING')
     * @param {string} reportTitle - 报表显示标题 (如 '收支项明细', '销售排行')
     * @param {Array} tableData - 要打印的表格数据 (Array of Objects)
     * @param {Object} [options] - 可选参数
     * @param {boolean} [options.autoPrint=false] - 是否直接触发打印（默认进入预览页）
     */
    goReportPrint(billType, reportTitle, tableData, options = {}) {
      if (!billType) {
        this.$message && this.$message.error('缺少报表类型参数 billType')
        return
      }
      if (!tableData) {
        tableData = []
      }

      // 将数据存入 localStorage，避免 URL 长度限制
      const storageKey = `REPORT_DATA_${billType}`
      try {
        localStorage.setItem(storageKey, JSON.stringify(tableData))
      } catch (e) {
        // localStorage 容量可能不够，降级使用 URL 参数（小规模数据可用）
        console.warn('[reportPrintHelper] localStorage 写入失败，可能数据量过大', e)
      }

      this.$router.push({
        path: '/print-normal/report-print',
        query: {
          billType: billType,
          billTypeName: reportTitle,
          reportTitle: reportTitle,
          autoPrint: options.autoPrint ? 'true' : 'false'
        }
      })
    }
  }
}